/**
 * Language Selector Replacer
 */

define(function(require, exports, module) {
    'use strict';

    const _ = require('underscore');
    const $ = require('j');
    const core = require('core');
    const user = require('user');
    const language = require('util/language.util');
    const device = require('util/device.util');
    const LangSelector = require('replacers/language/language-selector.view');
    const server = require('server');
    window.desktopExcludeLang = window.desktopExcludeLang ? window.desktopExcludeLang : [];
    window.mobileExcludeLang = window.mobileExcludeLang ? window.mobileExcludeLang : [];

    module.exports = LangSelector.extend({

        render: function() {
            const userLang = user.get('lang') || Playtech.Variables.defaultLocale;
            const isDesktop = device.formFactor === 'desktop';
            let allowedLocalesArr;
            try {
                allowedLocalesArr = isDesktop
                    ? _.difference(language.allowedLocales, window.desktopExcludeLang)
                    : _.difference(language.allowedLocales, window.mobileExcludeLang);
            } catch (e) {
                window.console.error('Excluded Lauguages is not defined');
                allowedLocalesArr = language.allowedLocales;
            }

            if (isDesktop) {
                this.$el.html(this.tmpl('language-selector-desktop', {
                    allowedLocales: allowedLocalesArr,
                    selected: userLang,
                    lang: userLang.slice(0,2)

                }));
            } else {
                this.$el.html(this.tmpl('language-selector', {
                    allowedLocales:  allowedLocalesArr,
                    selected: userLang,
                    lang: userLang.slice(0,2)
                }));
            }

            return this;
        },

        changeLanguage: function(e) {
            const isLoggedIn = user.isLoggedIn();
            LangSelector.prototype.changeLanguage.call(this, e);
            device.formFactor !== 'desktop' && core.trigger('popup:rendered');
            $('.fn-page-loader-overlay').removeClass('hidden');
            isLoggedIn && this.sendLangParam(e.currentTarget.dataset.lang);
        },

        sendLangParam: function(userLang) {
            const request = {
                ID: 35878,
                description: "Change Login Session Language",
                languageCode: userLang.slice(0,2),
                responses: [35879, 35880]
            };

            return server.send(request).done(function(response) {
                return response.data;
            });
        }
    }, {
        nameOfReplacers: [
            'LANGUAGE_SELECTOR'
        ]
    });
});